import prolog from "refractor/prolog";
export default prolog;